<template>
  <div>
    <input type="file" id="listupload" class="d-none" @change="importFile" accept=".xlsx" />
    <g-button icon="cloud_download" label="Export List (Excel)" class="ml-2" @onclick="exportRooms()" />
  </div>
</template>

<script>
import writeXlsxFile from "write-excel-file";
import BOOKING_ROOMS from "@/config/BOOKING_ROOMS";
import IMPORT_ROOM_SCHEMA from "@/config/IMPORT_ROOM_SCHEMA";
import { BookingRoomService } from "@/modules/bookings.rooms";

export default {
  methods: {
    importFile() {
      // Doesn't do anything?
    },
    exportRooms() {
      const exportData = [];
      const guestTypeMap = { CHILD: "Child", ADULT: "Adult" };

      // Column names
      exportData.push(Object.keys(IMPORT_ROOM_SCHEMA).map((key) => ({ value: key, type: String })));

      // Retrieve rooms
      const bookedRooms = this.$store.getters["BookingRoomStore/rooms"];

      // Process guests
      bookedRooms.forEach((room, index) => {
        room.nameList
          .sort((a, b) => `${a.first} ${a.last}`.localeCompare(`${b.first} ${b.last}`))
          .forEach((name, nameIndex) => {
            exportData.push([
              { type: String, value: BOOKING_ROOMS.find((rt) => rt.value === room.type)?.print },
              { type: Number, value: index + 1 },
              { type: String, value: name.first },
              { type: String, value: name.last },
              { type: String, value: guestTypeMap[name.about?.type] },
              { type: Number, value: name.about?.age ? Number(name.about.age) : null },
              { type: String, value: nameIndex === 0 ? room.meta?.request ?? null : null },
            ]);
          });
      });

      // Extra guests: Tour guide and driver
      const extraRoomList = BookingRoomService.getExtraRoomList(
        this.$store.getters["BookingDayStore/days"],
        this.$store.getters["BookingSupplierRoomStore/supplier_rooms"]
      );
      const singleRoomLabel = BOOKING_ROOMS.find((item) => item.value === "SINGLE_DK")?.print;
      const extraGuests = extraRoomList["ALL"] || [];
      const totalBookedRooms = bookedRooms.length;

      extraGuests.forEach((guest, guestIndex) => {
        exportData.push([
          { type: String, value: singleRoomLabel },
          { type: Number, value: totalBookedRooms + guestIndex + 1 },
          { type: String, value: guest.first_name },
          { type: String, value: guest.last_name },
          { type: String, value: guestTypeMap.ADULT },
          { type: Number, value: null },
          { type: String, value: null },
        ]);
      });

      writeXlsxFile(exportData, { fileName: "rooming-list.xlsx" });
    },
  },
};
</script>
